import { render, staticRenderFns } from "./MyNews4.vue?vue&type=template&id=526c4ef6&scoped=true"
import script from "./MyNews4.vue?vue&type=script&lang=js"
export * from "./MyNews4.vue?vue&type=script&lang=js"
import style0 from "./MyNews4.vue?vue&type=style&index=0&id=526c4ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c4ef6",
  null
  
)

export default component.exports